// extracted by mini-css-extract-plugin
export default {"navAddressWrapper":"citySearchBar_navAddressWrapper__n-fb0","navCityText":"citySearchBar_navCityText__2DCa9"};